import { 
	restoreMsgStorage, 
	scrollMsgsContainerDown, 
	createNewChat
} from "./chat.js";

export function kitanBotOpen() {
	const container = document.querySelector(".kitan-bot-container");
	const shadow = document.querySelector(".kitan-bot-container-fadeshadow");
	const btn = document.querySelector(".kitan-bot-btn");

	if(!restoreMsgStorage()) {
		createNewChat();
	}


	shadow.classList.remove("fadeout");
	setTimeout(() => {
		container.classList.add("fadein");
	}, 150);

	btn.classList.remove("kb-state-closed");
	btn.classList.add("kb-state-opened");
	setTimeout(() => {
		scrollMsgsContainerDown();
	}, 100);
}

export function kitanBotClose() {
	const container = document.querySelector(".kitan-bot-container");
	const shadow = document.querySelector(".kitan-bot-container-fadeshadow");
	const btn = document.querySelector(".kitan-bot-btn");

	container.classList.remove("fadein");
	setTimeout(() => {
		shadow.classList.add("fadeout");
	}, 150);
	
	btn.classList.remove("kb-state-opened");
	btn.classList.add("kb-state-closed");
}